"use-strict";

function ExamPosition() {
   
    if (window.Goftino) {
       
        window.Goftino.setWidget({
            marginRight: 30,
            marginLeft: 15,
            marginBottom: 30
          
        });
      
    } else {
        window.addEventListener("goftino_ready", function() {
            Goftino.setWidget({
                marginRight: 30,
                marginLeft: 15,
                marginBottom: 30,

            });
        });
    }

}
function ScorePositionOpen() {
   
    if (window.Goftino) {
       
        window.Goftino.setWidget({
            marginRight: 30,
            marginLeft: 15,
            marginBottom: 30,
            hasIcon: false
        });
        window.Goftino.close();
    } else {
        window.addEventListener("goftino_ready", function() {
            Goftino.setWidget({
                marginRight: 30,
                marginLeft: 15,
                marginBottom: 30,

            });
        });
    }

}
function ScorePositionClose() {
   
    if (window.Goftino) {
       
        window.Goftino.setWidget({
            marginRight: 30,
            marginLeft: 15,
            marginBottom: 30,
            hasIcon: true
        });
        window.Goftino.open();
    } else {
        window.addEventListener("goftino_ready", function() {
            Goftino.setWidget({
                marginRight: 30,
                marginLeft: 15,
                marginBottom: 30,

            });
        });
    }

}

function HomePosition() {
    if (window.Goftino) {
        window.Goftino.setWidget({
            marginRight: 30,
            marginLeft: 15,
            marginBottom: 80
        });
    } else {
        window.addEventListener("goftino_ready", function() {
            Goftino.setWidget({
                marginRight: 30,
                marginLeft: 15,
                marginBottom: 80
            });
        });
    }
}